import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const Image_Fragment = graphqlShopifyStorefront(`
  fragment Image on Image {
    __typename
    altText
    height
    id
    thumbhash
    url
    width
  }
`);
